<template>
  <div>
   
    <v-card-title>
      <h2>Training Information Details</h2>
      <v-spacer></v-spacer>

      <v-btn class="mx-0" color="info" title="Download" @click="downloadFIle">
        <v-icon color="white">cloud_download</v-icon>
      </v-btn>  

      <v-btn color="error" @click="previous" title="Back">
          <v-icon>arrow_back_ios</v-icon>Back
        </v-btn>

    </v-card-title>

     <table width="100%" class="tblClass">
      <tbody>     
        <tr>
          <th colspan="4" style="font-weight:bold; font-size:20px; padding:10px 0px;">Training Information Details</th>
        </tr>
        <tr>
          <th>Project Name</th>
          <td colspan="3" style="font-weight:bold; padding-left:8px;">{{trainingInfo.project_name}}</td>
        </tr>
        <tr>
          <td colspan="4">&nbsp;</td>
        </tr>

        <tr class="textCenter">          
          <th>Training ID.</th> 
          <th>Training Title.</th> 
          <th>Training Category.</th> 
        </tr>

        <tr class="textCenter">          
          <td>{{trainingInfo.training_code}}</td>
          <td>{{trainingInfo.training_title}}</td>
          <td>{{trainingInfo.name}}</td>
        </tr>


        <tr class="textCenter">
          <th>From Date</th> 
          <th>To date</th>
          <th>Training Type</th> 
         
        </tr>
        <tr class="textCenter">
          <td>{{(trainingInfo.start_date) ? changeFormateDMY(trainingInfo.start_date) : ''}}</td>
          <td>{{(trainingInfo.end_date) ? changeFormateDMY(trainingInfo.end_date) : ''}}</td>
          <td>{{trainingInfo.training_type}}</td>
          
        </tr>


        <tr class="textCenter">
          <th>Venue</th> 
          <th>Organizer </th>
          <th>Status</th> 
         
        </tr>
        <tr class="textCenter">
          <td>{{trainingInfo.venue}}</td>
          <td>{{(trainingInfo.is_open == 3) ? plan_org_name  : trainingInfo.org_name }}</td>
          <td>
            <span v-if="trainingInfo.is_open == 1" class="active">Open</span>
            <span v-else-if="trainingInfo.is_open == 0" class="in-active">Close</span>
            <span v-else class="active">Plan</span>
        </td>
         
        </tr>

        <tr class="textCenter">
          <th>GoB Fund (BDT)</th> 
          <th>IDA Fund (BDT)</th>
          <th></th> 
          
        </tr>
        <tr class="textCenter">
          <td>{{trainingInfo.GoB_amount | currency}}</td>
          <td>{{trainingInfo.ida_amount | currency}}</td>
          <td></td>
          
        </tr>
            

      </tbody>
    </table>
    <br><br>

     <table width="100%" class="tblClass">
      <tbody>
        <tr>
          <th colspan="6" style="font-weight:bold; font-size:20px; padding:10px 0px;">Participant Information</th>
        </tr>
        <tr>
          <th>Participant Name</th>
          <th>Designation</th>
          <th>Department/Division</th>
          <th>Organization</th>
          <th>Mobile</th>
          <th>E-mail</th>
        </tr>
        <tr v-for="item in trainingParticipant" class="textCenter" :key="item">
          <td>{{item.participant_name}}</td>
          <td>{{item.designation}}</td>
          <td>{{item.division_department}}</td>
          <td>{{item.institute}}</td>
          <td>{{item.phone}}</td>
          <td>{{item.email}}</td>
        <tr>
        </tr>
      </tbody>      
    </table>
    <br><br>

    <table width="100%" class="tblClass">
      <tbody>
        <tr>
          <th colspan="4" style="font-weight:bold; font-size:20px; padding:10px 0px;">Cost Information</th>
        </tr>
        <tr>
          <th>Head Code</th>
          <th>Exchange Rate</th>
          <th>USD</th>
          <th>BDT</th>
          
        </tr>
        <tr v-for="item in  trainingCostInfo" class="textCenter" :key="item">
          <td>{{item.name}}</td>
          <td>{{item.exchange_rate}}</td>
          <td>{{item.usd_amount | currency}}</td>
          <td>{{item.bdt_amount | currency}}</td>
        </tr>
        <tr class="textCenter" style="font-weight:bold;">
          <td colspan="2">Total</td>
          <td>{{ totalUsd | currency }}</td>
          <td>{{ totalBdt | currency }}</td>
        </tr>
      </tbody>      
    </table>
    <br><br>
    <table width="100%" class="tblClass" v-if="transaction.length > 0">
      <tbody>
        <tr>
          <th colspan="4" style="font-weight:bold; font-size:20px; padding:10px 0px;">Transaction Information</th>
        </tr>
      </tbody>      
    </table>
    
    <br><br>
    <table width="100%" class="tblClass"  v-for="item in transaction" :key="item">
      <tbody>
        <tr>
          <th colspan="8" style="font-weight:bold; font-size:20px; padding:10px 0px;">Transaction No: {{ item.master_data.voucher_number}}</th>
        </tr>
        <tr>
          <th colspan="2">Transaction Type</th>
          <th colspan="2">USD Rate</th>
          <th colspan="2">Date</th>
          <th colspan="2">Narration</th>
        </tr>
        <tr  class="textCenter">
          <td colspan="2">{{item.master_data.voucher_type}}</td>
          <td colspan="2">{{item.master_data.usd_rate}}</td>
          <td colspan="2">{{changeFormateDMY(item.master_data.voucher_date)}}</td>
          <td colspan="2">{{item.master_data.narration}}</td>
        </tr>
        

      <tr class="textCenter">
				<th rowspan="2">Economic/Account Name</th>
				<th colspan="2">Debit</th>
				<th colspan="2">Credit</th>
				<th rowspan="2">Source Of Fund</th>
				<th rowspan="2">Credit ID</th>
			</tr>
			<tr class="textCenter">
				<th>BDT</th>
				<th>USD </th>
				<th>BDT</th>
				<th>USD</th>
			</tr>
      <tr  class="textCenter" v-for="item1 in item.details" :key1="item1">
        <td>{{item1.eco_code}}</td>
        <td>{{item1.bdt_debit}}</td>
        <td>{{item1.usd_debit}}</td>
        <td>{{item1.bdt_credit}}</td>
        <td>{{item1.usd_credit}}</td> 
        <td>{{item1.fund_source}}</td>
        <td>{{(item1.credit_id == 1) ? 'Credit A' : 'Credit B'}}</td>
      </tr>
      </tbody>      
      <br><br>
    </table>
    

 </div>
</template>
<script>
const commonService = require('../../../services/common.service');
import Axios from "axios";
import ServerPath from '../../../server-path/server-path';

export default {

  data: () => ({
    valid: true,
    totalUsd:0,
    totalBdt:0,    

     queryData2: {
      trainInfoId: ""
    },

    packagesList:[],
    packagesEcoList:[],
    executionList:[],
    trainingInfo:[],
    plan_org_name:'',
    trainingParticipant:[],  
    trainingCostInfo:[],
    transaction:[]    

  }),

  created() {
    let query_Data2 = this.queryData2;
        
        (query_Data2.trainInfoId = sessionStorage.getItem("trainInfoId"))
         

        commonService.getServerSideData(query_Data2, "training_info_details")
        .then(res => {
          this.trainingInfo = res.trainingInfo[0]
          this.plan_org_name = res.plan_org_name
          this.trainingParticipant = res.participantInfo
          this.trainingCostInfo = res.costInfo
          this.transaction = res.transaction
          console.log(this.trainingParticipant)
          
          // Cost total Calculation
          this.trainingCostInfo.forEach(element => {
            this.totalUsd += parseFloat(element.usd_amount); 
            this.totalBdt += parseFloat(element.bdt_amount); 
          });
        })   
  },

  
  methods: {

    satusName(statusId){
      let status_list = [
        { id: "1", name: "Plan" },
        { id: "2", name: "Execute" },
        { id: "3", name: "Revision" },
        { id: "4", name: "Merge" },
        { id: "5", name: "Split" },
        { id: "6", name: "Close" },
        { id: "7", name: "Terminate" },
        { id: "8", name: "Procured" },
      ];
      if (statusId) {
        return status_list.filter(function(a) {
          return a.id == statusId;
        })[0].name;
        //console.log('status_list', status_list)
      }
    },

    downloadFIle(){

      let query_Data2 = this.queryData2;
        
        (query_Data2.trainInfoId = sessionStorage.getItem("trainInfoId"))
        

      let parameters = new URLSearchParams({ ...query_Data2}).toString();
      let route = ServerPath.serverPath+'/training-details-pdf?'+parameters;
      window.open(route, '_blank');
    },

    previous(){
      this.$router.push('/training/training-info') 
    }
  }
};
</script>

<style scoped>
.tblClass{
  border-collapse: collapse;
}
.tblClass tr th,
.tblClass tr td{
  border:1px solid #CCC;
  padding:8px 0px;
}
.textCenter tr th,
.textCenter tr td,
.textCenter{
  text-align: center;  
}
</style>


// WEBPACK FOOTER //
// src/components/training/training_information/detailsView.vue